import { Component, OnInit, Input, OnChanges, SimpleChanges, EventEmitter } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { PasswordForm } from 'src/app/components/account/reset-password.component';
import { ControlsOf } from 'src/app/utils/controls-of';

@Component({
  selector: 'password-match',
  templateUrl: './password-match.component.html',
  styleUrls: ['./password-match.component.css'],
})
export class PasswordMatchComponent {
  @Input() passwordForm: FormGroup<ControlsOf<PasswordForm>>;

  get isPasswordMatch() {
    return this.passwordForm?.touched && this.passwordForm?.hasError('passwordsDontMatch');
  }
}
